import {
  Component, Input, HostBinding, HostListener, ElementRef,
  EventEmitter, Renderer2, OnInit, Output,
} from '@angular/core';
import {trigger,
    state, style, transition, animate} from '@angular/animations';


@Component({
  moduleId: module.id,
  selector: 'collapse-height, [collapseHeight]',
  template: `
    <div class="collapse-content" [ngClass]="collapseClass">
    <ng-content></ng-content></div>
  `,
  styleUrls: ['collapse.component.scss'],
  animations: [
    trigger('collapseAnimation', [
      state('void', style({height: '0', visibility: 'hidden'})),
      state('collapsed', style({height: '0', visibility: 'hidden'})),
      state('expanded', style({height: '*', visibility: 'visible'})),
      transition('* => expanded', [
        animate('0.3s ease-out')
      ]),
      transition('* => collapsed', [
        animate('0.3s ease-out')
      ]),

    ])
  ]
})
export class CollapseComponent implements OnInit {
  @HostBinding('class.collapsed')
  @Input() collapse: boolean = true;

  @Input() enabled: boolean = true;

  @Input() collapseClass: string = '';

  @Input() collapseDisplay: boolean = false;

  @Output() animationDone: EventEmitter<boolean> = new EventEmitter<boolean>();

  @HostBinding('@collapseAnimation') get collapsed(): string {
    return this.collapse ? 'collapsed' : 'expanded';
  }

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    if (this.collapse) {
      this.renderer.setStyle(this.elementRef.nativeElement, 'height', '0');
      this.setOverflow('hidden');
      if (this.collapseDisplay) { this.display(false); }
    }
  }

  @HostListener('@collapseAnimation.start') handleAnimationStarted() {
    this.setOverflow('hidden');
    if (this.collapseDisplay) { this.display(true); }
  }

  @HostListener('@collapseAnimation.done') handleAnimationDone() {
    this.setOverflow(this.collapse ? 'hidden' : 'visible');
    if (this.collapseDisplay && this.collapse) {
      this.display(false);
    }
    this.animationDone.emit(this.collapse);
  }

  public toggle() {
    if (this.enabled) {
      this.collapse = !this.collapse;
    }
  }

  public setCollapsed(collapse: boolean = true) {
    this.collapse = collapse;
  }

  public isEnabled() {
    return this.enabled;
  }

  private setOverflow(overflow: string): void {
    this.renderer.setStyle(this.elementRef.nativeElement, 'overflow', overflow);
  }

  private display(display: boolean): void {
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', display ? 'block' : 'none');
  }
}
